<template>
  <div>
    <v-col class="pa-0">
      <fiche-header @back="back" :title="route?.ficheHeader">
      </fiche-header>
    </v-col>

    <v-row class="ma-0">
      <div :class="!isFullscreen ? 'col-6 pt-0' : 'col-12 pt-6 pr-6'">
        <v-col class="pl-6 pt-0">
          <component ref="SECTION_COMPONENT" :is="sectionComponent" v-if="sectionComponent" v-bind="currentProperties" v-on="events"></component>
        </v-col>
      </div>
    </v-row>

    <Transition name="scrim">
      <div v-if="sectionOpen" class="global-scrim" @click="sectionOpen = false"></div>
    </Transition>

    <Transition name="slide-panel">
      <div v-if="sectionOpen" class="local-panel-wrap">
        <div class="local-panel col-5">
          <component :is="crudSection.component" ref="SECTION_DIALOG" v-bind="crudProperties" v-on="crudEvents"></component>
        </div>
      </div>
    </Transition>

  </div>
</template>

<script lang="ts">
import {storeSession} from "@/generated/stores";
import Fiche from "@/framework/base/classes/Fiche";
import Route from "@/generated/classes/Route";
import {defineComponent, type PropType} from "vue";
import {useRouter} from "vue-router";
import FicheHeader from "@/framework/base/components/FicheHeader.vue";
import Section from '@/framework/base/classes/Section';

export default defineComponent({
  components: {
    FicheHeader
  },
  props: {
    fiche: {
      type: Object as PropType<Fiche>,
      required: true
    },
    fieldOnly: {
      type: Boolean
    },
    attribut: {
      type: Object as PropType<unknown> | undefined,
    },
    route: {
      type: Object as PropType<Route>,
      required: false
    },
    toggleNotif: {
      type: Boolean
    }
  },
  data() {
    return {
      sectionOpen: false,
      crudSection: new Section(),
      router: useRouter(),
    }
  },
  computed: {
    events(): Record<string, () => void> {
      // eslint-disable-next-line
      const event: any = {};
      event["selectItem"] = (item: unknown) => this.selectItem(item);
      event["goBack"] = () => this.goBack();
      event["back"] = () => this.back();
      event["openCrud"] = (item: unknown) => this.openCrud(item);
      return event;
    },
    currentProperties() {
      return {
        [this.route.data.propType]: this.route.data.propData,
        extended: true,
        fieldOnly: this.fieldOnly,
        attribut: this.attribut,
        route: this.route,
        toggleNotif: this.toggleNotif,
        isAbstract: true
      };
    },
    sectionComponent() {
      if (this.route && this.route.data && this.route.data.component) {
        return this.route.data.component;
      } else {
        return null;
      }
    },
    isFullscreen() {
      if (this.route && this.route.data && this.route.data.component) {
        return this.route.data.fullscreen;
      } else {
        return false;
      }
    },
    crudProperties (): any {
      return {
        [this.crudSection.type]: this.crudSection.data,
        type: this.crudSection.type,
        data: this.crudSection.data,
        [this.crudSection.propType]: this.crudSection.propData,
        autoClear: this.crudSection.autoClear,
        ressource: this.crudSection.ressource,
        picto: this.crudSection.picto,
        showButton: this.crudSection.showButton,
        autoSave: this.crudSection.autoSave,
        contextId: this.crudSection.contextId,
        buttons: this.crudSection.buttons,
        chat: this.crudSection.chat,
        fullscreen: false,
        extended: true,
        fromSection: this.crudSection.sectionName,
        section: this.crudSection,
        owner: this.crudSection.owner,
        adminInfo: this.crudSection.adminInfo,
        fiche: this.fiche,
        isAbstract: true,
        requiredAttributs: this.crudSection.requiredAttributs,
      };
    },
    crudEvents(): Record<string, () => void> {
      // eslint-disable-next-line
      const event: any = {};
      event["saved"] = (value: any) => this.setSaved(value);
      event["closeDialog"] = () => this.sectionOpen = false;
      return event;
    },
  },
  created(): void {
    storeSession.SetShowList(true);
  },
  beforeUnmount(): void {
    storeSession.SetShowList(false);
  },

  methods: {
    selectItem(item: unknown): void {
      this.$emit("selectItem", item)
    },
    back(): void {
      this.$emit("back")
    },
    goBack(): void {
      this.router.go(-1);
    },
    openCrud(section: any): void {
      this.crudSection = section;
      this.sectionOpen = true;
    },
    setSaved (value: any): void {
      const section = this.$refs.SECTION_COMPONENT as any;
      if (section && typeof section.saved === 'function') {
        section.saved(value);
        this.sectionOpen = false;
      }
    },
  }
})

</script>
